/**
 * 来場者画面の遅延読み込みフォールバック
 * 画面chunkの取得中も来場者UIと一貫した読み込み状態を表示します。
 */

import React from "react";

/**
 * 来場者画面を準備している間の全画面表示
 * @returns {JSX.Element} 読み込みフォールバック
 */
const VisitorRouteLoadingFallback = () => {
  return (
    <div
      aria-busy="true"
      aria-label="画面を読み込み中"
      className="flex min-h-screen items-center justify-center bg-app-quest-sky px-5 py-8"
      role="status"
    >
      <div className="w-full max-w-sm border-4 border-app-quest-night bg-app-panel px-6 py-7 text-center shadow-[6px_6px_0_rgba(22,36,58,0.34)]">
        <p className="mx-auto w-fit border-2 border-app-quest-night bg-app-quest-gold px-3 py-1 text-xs font-black tracking-[0.18em] text-app-quest-night">
          LOADING
        </p>
        <div
          aria-hidden="true"
          className="mt-5 flex items-center justify-center gap-2"
        >
          <span className="h-3 w-3 animate-pulse bg-app-quest-night" />
          <span className="h-3 w-3 animate-pulse bg-app-quest-gold [animation-delay:150ms]" />
          <span className="h-3 w-3 animate-pulse bg-app-quest-night [animation-delay:300ms]" />
        </div>
        <p className="mt-5 text-xl font-black tracking-wide text-app-quest-night">
          冒険の準備中
        </p>
        <p className="mt-2 text-sm font-bold leading-6 text-app-text-secondary">
          画面を読み込んでいます。少しだけお待ちください。
        </p>
      </div>
    </div>
  );
};

export default VisitorRouteLoadingFallback;
